export default function basketConditionFactory(ModalService) {
    var obj = this;

    obj.modal = function () {
        // FIXES : http://stackoverflow.com/questions/19305821/multiple-modals-overlay
        // Just provide a template url, a controller and call 'showModal'.

        return ModalService.showModal({
            template: require("./modal-template.html"),
            controller: "basketConditionsModalController",
            inputs: {},
        }).then(function (modal) {
            // The modal object has the element built, if this is a bootstrap modal
            // you can call 'modal' to show it, if it's a custom modal just show or hide
            // it as you need to.

            modal.element.modal();

            return modal.close
                .then(function (answer) {
                    return answer;
                })
                .catch(function (error) {
                    // error contains a detailed error message.
                });
        });
    };

    return obj;
}
